import React, {ReactNode} from "react";
import {I18nGlobals} from "../../shared/translation/i18nInterface";
import {MessageGlobals} from "../../shared/log/MessageInterface";
import {AdminGlobals} from "../Admin";
import Dialogs, {DialogsGlobals} from "../../shared/dialog/components/Dialogs";
import AdminContext from "../AdminContext";
import RestartDialog from "./components/RestartDialog";
import AdminLoginDialog from "./components/AdminLoginDialog";
import LicenseDialog from "./components/LicenseDialog";
import FunctionsDialog from "./components/FunctionsDialog";
import NewsDialog from "./components/NewsDialog";
import LocalAuthDialog from "./components/LocalAuthDialog";
import TsaDialog from "./components/TsaDialog";
import ProxyDialog from "./components/ProxyDialog";
import {
	ApplicationConfigKeystore,
	License,
	NewsPanel,
	OAuth,
	Portal,
	ProxiesApplication,
	ServerConfigLocalAuth,
	ServerConfigUserStorage,
	TruststoreServer,
	Users
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import UserSourceDialog from "./components/UserSourceDialog";
import UserDialog from "./components/UserDialog";
import {LoginType} from "../../shared/models/LoginType";
import DesignDialog from "./components/DesignDialog";
import {DesignType} from "../../shared/models/DesignType";
import KeystoreDialog from "./components/KeystoreDialog";
import TruststoreDialog from "./components/TruststoreDialog";
import {HelperGlobals} from "../../shared/components/Helper";
import AdminLogoutDialog from "./components/AdminLogoutDialog";
import OAuthServerDialog from "./components/OAuthServerDialog";
import OAuthPortalDialog from "./components/OAuthPortalDialog";
import PortalAuthDialog from "./components/PortalAuthDialog";
import FunctionHelper from "../../shared/helper/FunctionHelper";
import {AdministrationGlobals} from "../session/Administration";
import AdminDebugDialog, {AdminDebugGlobals} from "./components/AdminDebugDialog";
import PortalPureComponent from "../../shared/components/PortalPureComponent";
import {PortalTsa} from "../../shared/models/PortalTsa";

export interface AdminDialogsGlobals extends DialogsGlobals {
	showRestartDialog?: boolean;
	showAdminLoginDialog?: boolean;
	adminLoginParameter?: LoginType;
	showAdminLogoutDialog?: boolean;
	showLicenseDialog?: boolean;
	licenseParameter?: License;
	showFunctionsDialog?: boolean;
	functionsParameter?: Portal;
	showNewsDialog?: boolean;
	newsParameter?: NewsPanel;
	showLocalAuthDialog?: boolean;
	LocalAuthParameter?: ServerConfigLocalAuth;
	showTsaDialog?: boolean;
	tsaParameter?: PortalTsa;
	showProxyDialog?: boolean;
	proxyParameter?: ProxiesApplication;
	showUserDialog?: boolean;
	userParameter?: Users;
	showUserSourceDialog?: boolean;
	userSourceParameter?: ServerConfigUserStorage;
	showDesignDialog?: boolean;
	designParameter?: DesignType;
	showKeystoreDialog?: boolean;
	keystoreParameter?: ApplicationConfigKeystore;
	showTruststoreDialog?: boolean;
	truststoreParameter?: TruststoreServer;
	showOAuthServerDialog?: boolean;
	oAuthServerParameter?: OAuth;
	showOAuthPortalDialog?: boolean;
	oAuthPortalParameter?: OAuth;
	showPortalAuthDialog?: boolean;
	portalAuthParameter?: Portal;
	showDebugDialog?: boolean;
}

interface AdminDialogsProperties extends AdminDialogsGlobals, AdminGlobals, MessageGlobals, I18nGlobals, HelperGlobals,
	AdministrationGlobals, AdminDebugGlobals {
	context: AdminContext;
}

export default class AdminDialogs extends PortalPureComponent<AdminDialogsProperties, any> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let isReconnecting: boolean = FunctionHelper.applyValue(this.props.showReconnectDialog, false);

		return (
			<>
				{!isReconnecting &&
					<>
						<RestartDialog {...this.props}
									   visible={FunctionHelper.applyValue(
										   this.props.showRestartDialog, false
									   )}
									   hide={() => this.props.context.getPage().setState({
										   showRestartDialog: false
									   })}/>
						<AdminLoginDialog {...this.props}
										  visible={FunctionHelper.applyValue(
											  this.props.showAdminLoginDialog, false
										  )}
										  hide={() => this.props.context.getPage().setState({
											  showAdminLoginDialog: false
										  })}
										  parameter={this.props.adminLoginParameter}/>
						<AdminLogoutDialog {...this.props}
										   visible={FunctionHelper.applyValue(
											   this.props.showAdminLogoutDialog, false
										   )}
										   hide={() => this.props.context.getPage().setState({
											   showAdminLogoutDialog: false
										   })}/>
						<LicenseDialog {...this.props}
									   visible={FunctionHelper.applyValue(
										   this.props.showLicenseDialog, false
									   )}
									   hide={() => this.props.context.getPage().setState({
										   showLicenseDialog: false
									   })}
									   parameter={this.props.licenseParameter}/>
						<FunctionsDialog {...this.props}
										 visible={FunctionHelper.applyValue(
											 this.props.showFunctionsDialog, false
										 )}
										 hide={() => this.props.context.getPage().setState({
											 showFunctionsDialog: false
										 })}
										 parameter={this.props.functionsParameter}/>
						<NewsDialog {...this.props}
									visible={FunctionHelper.applyValue(
										this.props.showNewsDialog, false
									)}
									hide={() => this.props.context.getPage().setState({showNewsDialog: false})}
									parameter={this.props.newsParameter}/>
						<LocalAuthDialog {...this.props}
										 visible={FunctionHelper.applyValue(
											 this.props.showLocalAuthDialog, false
										 )}
										 hide={() => this.props.context.getPage().setState({
											 showLocalAuthDialog: false
										 })}
										 applicationConfig={this.props.applicationConfig}
										 parameter={this.props.LocalAuthParameter}/>
						<TsaDialog {...this.props}
								   visible={FunctionHelper.applyValue(
									   this.props.showTsaDialog, false
								   )}
								   hide={() => this.props.context.getPage().setState({showTsaDialog: false})}
								   parameter={this.props.tsaParameter}/>
						<ProxyDialog {...this.props}
									 visible={FunctionHelper.applyValue(
										 this.props.showProxyDialog, false
									 )}
									 hide={() => this.props.context.getPage().setState({showProxyDialog: false})}
									 parameter={this.props.proxyParameter}/>
						<UserSourceDialog {...this.props}
										  visible={FunctionHelper.applyValue(
											  this.props.showUserSourceDialog, false
										  )}
										  hide={() => this.props.context.getPage().setState({
											  showUserSourceDialog: false
										  })}
										  parameter={this.props.userSourceParameter}/>
						<UserDialog {...this.props}
									visible={FunctionHelper.applyValue(
										this.props.showUserDialog, false
									)}
									hide={() => this.props.context.getPage().setState({showUserDialog: false})}
									parameter={this.props.userParameter}/>
						<DesignDialog {...this.props}
									  visible={FunctionHelper.applyValue(
										  this.props.showDesignDialog, false
									  )}
									  hide={() => this.props.context.getPage().setState({showDesignDialog: false})}
									  parameter={this.props.designParameter}/>
						<KeystoreDialog {...this.props}
										visible={FunctionHelper.applyValue(
											this.props.showKeystoreDialog, false
										)}
										hide={() => this.props.context.getPage().setState({
											showKeystoreDialog: false
										})}
										parameter={this.props.keystoreParameter}/>
						<TruststoreDialog {...this.props}
										  visible={FunctionHelper.applyValue(
											  this.props.showTruststoreDialog, false
										  )}
										  hide={() => this.props.context.getPage().setState({
											  showTruststoreDialog: false
										  })}
										  parameter={this.props.truststoreParameter}/>
						<OAuthServerDialog {...this.props}
										   visible={FunctionHelper.applyValue(
											   this.props.showOAuthServerDialog, false
										   )}
										   hide={() => this.props.context.getPage().setState({
											   showOAuthServerDialog: false
										   })}
										   parameter={this.props.oAuthServerParameter}/>
						<OAuthPortalDialog {...this.props}
										   visible={FunctionHelper.applyValue(
											   this.props.showOAuthPortalDialog, false
										   )}
										   hide={() => this.props.context.getPage().setState({
											   showOAuthPortalDialog: false
										   })}
										   parameter={this.props.oAuthPortalParameter}/>
						<PortalAuthDialog {...this.props}
										  visible={FunctionHelper.applyValue(
											  this.props.showPortalAuthDialog, false
										  )}
										  hide={() => this.props.context.getPage().setState({
											  showPortalAuthDialog: false
										  })}
										  serverConfig={this.props.serverConfig}
										  parameter={this.props.portalAuthParameter}/>
						<AdminDebugDialog {...this.props}
										  visible={FunctionHelper.applyValue(
											  this.props.showDebugDialog, false
										  )}
										  hide={() => this.props.context.getPage().setState({
											  showDebugDialog: false
										  })}/>
					</>
				}
				<Dialogs {...this.props}/>
			</>
		);
	}
}